var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnSpedizioni = function SvgIcnSpedizioni(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50.5 50.5",
    style: {
      enableBackground: "new 0 0 50.5 50.5"
    },
    xmlSpace: "preserve",
    fill: "#fff",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.5,28.8L43.3,23c-0.3-1.6-0.8-2.8-1.6-3.8c-1-1.2-2.4-1.8-4.1-1.8h-4.6V9.6c0-1.1-0.9-2-2-2s-2,0.9-2,2v19.1 H9.9c-1.1,0-2,0.9-2,2s0.9,2,2,2h33.3c1.9,0.2,3.4,1.7,3.4,3.6v5.1h-4.3c-0.8-2.3-3-3.9-5.6-3.9s-4.8,1.6-5.6,3.9H18.9 c-0.8-2.3-3-3.9-5.6-3.9c-2.6,0-4.8,1.6-5.6,3.9c-2.1-0.1-3.8-1.8-3.8-3.9v-20c0-1.1-0.9-2-2-2s-2,0.9-2,2v20c0,4.3,3.5,7.8,7.7,7.9 c0.8,2.3,3,3.9,5.6,3.9c2.6,0,4.8-1.6,5.6-3.9h12.2c0.8,2.3,3,3.9,5.6,3.9s4.8-1.6,5.6-3.9h6.3c1.1,0,2-0.9,2-2v-7.1 C50.5,32.6,47.9,29.5,44.5,28.8z M32.9,21.4h4.6c0.6,0,1.4,0,1.9,2.4c0,0,0,0,0,0l1,4.9h-7.5V21.4z M13.3,45.4c-1.1,0-2-0.9-2-2 s0.9-2,2-2s2,0.9,2,2S14.4,45.4,13.3,45.4z M36.7,45.4c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S37.8,45.4,36.7,45.4z M0.1,9.6 c0-1.1,0.9-2,2-2h16.1l-3.1-3c-0.8-0.8-0.8-2,0-2.8s2-0.8,2.8,0l4.5,4.4c0.9,0.9,1.5,2.2,1.5,3.5c0,1.3-0.5,2.6-1.5,3.5L18,17.4 c-0.4,0.4-0.9,0.6-1.4,0.6c-0.5,0-1-0.2-1.4-0.6c-0.8-0.8-0.8-2,0-2.8l3.1-3H2.1C1,11.5,0.1,10.7,0.1,9.6z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnSpedizioni, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_spedizioni.55c7167c.svg";
export { ForwardRef as ReactComponent };